export default __webpack_public_path__ + "static/media/img_17.991153d2.png";